import { Text } from '@chakra-ui/react';
import { useCoinMode } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';

export const useUnstakeHint = (): {
  title: string;
  shortText: string;
  shortTextDesktop?: JSX.Element;
  longText: JSX.Element;
} => {
  const t = useTranslations();
  const globalCoinMode = useCoinMode();

  if (globalCoinMode === 'atom') {
    return {
      title: t('Unstake {coin}', {
        coin: 'ATOM & NFTs',
      }),
      longText: (
        <>
          {t('unstake-atom-how-it-works-desc-{br}', {
            br: () => <br />,
          })}
        </>
      ),
      shortText:
        t('unstake-atom-how-it-works-desc-{br}', {
          br: () => '',
        }).slice(0, 64) + '...',
      shortTextDesktop: (
        <>
          <Text color="black" fontWeight="bold" display="inline">
            {t('Unstake')}:{' '}
          </Text>
          {t('unstake-atom-how-it-works-desc-{br}', {
            br: () => '',
          }).slice(0, 125) + '...'}
        </>
      ),
    };
  }

  return {
    title: t('Unstake {coin}', {
      coin: 'CRO & NFTs',
    }),
    longText: (
      <>
        {t('unstake-cro-how-it-works-desc-{br}', {
          br: () => <br />,
        })}
      </>
    ),
    shortText:
      t('unstake-cro-how-it-works-desc-{br}', {
        br: () => '',
      }).slice(0, 65) + '...',
    shortTextDesktop: (
      <>
        <Text color="black" fontWeight="bold" display="inline">
          {t('Unstake')}:{' '}
        </Text>
        {t('unstake-cro-how-it-works-desc-{br}', {
          br: () => '',
        }).slice(0, 128) + '...'}
      </>
    ),
  };
};
